export default {"src":"/_next/static/media/listen.fbe6870a.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};